import { createSystem, defaultConfig, defineConfig, mergeConfigs } from "@chakra-ui/react";
import { buttonRecipe } from "../recipes/button";
import { cardRecipe } from "../recipes/card";
import { menuRecipe } from "../recipes/menu";
import { dialogRecipe } from "../recipes/dialog";

const theme = defineConfig({
  globalCss: {
    'body': {
      fontFamily: '"Geist", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      bg: '#fafafa',
      _dark: {
        bg: '#000'
      }
    }
  },
  theme: {
    tokens: {
      fonts: {
        body: { value: '"Geist", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif' },
        heading: { value: '"Geist", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif' },
      },
    },
    recipes: {
      button: buttonRecipe,
    },
    slotRecipes: {
      card: cardRecipe,
      menu: menuRecipe,
      dialog: dialogRecipe
    }
  }
})

const config = mergeConfigs(defaultConfig, theme)

export default createSystem(config)